import { t } from "@/i18n-js/instance";
import { SpaceHeaderTitleText } from "@circle-react/components/Spaces/Header/SpaceHeaderTitle/SpaceHeaderTitleText";
import { Icon } from "@circle-react/components/shared/Icon";
import { Dropdown } from "@circle-react/components/shared/uikit/Dropdown";
import type { SpaceGroup } from "@circle-react/types";
import { DeleteSpaceGroupModal } from "./DeleteSpaceGroupModal";
import { useManageSpaceGroupActions } from "./SpaceGroupHeaderActions/useManageSpaceGroupActions";

export interface SpaceGroupHeaderTitleProps {
  hasDropdown?: boolean;
  spaceGroup: SpaceGroup;
}

export const SpaceGroupHeaderTitle = ({
  spaceGroup,
  hasDropdown = true,
}: SpaceGroupHeaderTitleProps) => {
  const {
    canManage,
    shouldShowDeleteModal,
    spaceModal,
    editSpaceGroupModal,
    addSpaceGroupMemberModal,
    toggleDeleteModal,
  } = useManageSpaceGroupActions({ spaceGroup });

  if (!canManage || !hasDropdown) {
    return (
      <SpaceHeaderTitleText truncate>{spaceGroup.name}</SpaceHeaderTitleText>
    );
  }

  return (
    <>
      <DeleteSpaceGroupModal
        spaceGroupId={spaceGroup.id}
        show={shouldShowDeleteModal}
        onClose={toggleDeleteModal}
      />
      <Dropdown
        direction="bottom-start"
        button={
          <Dropdown.MenuButton>
            <SpaceHeaderTitleText truncate>
              {spaceGroup.name}
            </SpaceHeaderTitleText>
            <Icon
              size={16}
              type="caret-down-bold"
              className="text-dark transition-all duration-100 group-hover:mt-1"
            />
          </Dropdown.MenuButton>
        }
      >
        <Dropdown.ItemWithLink
          onClick={() => editSpaceGroupModal.show({ spaceGroup })}
        >
          {t("space_groups.edit_space_group")}
        </Dropdown.ItemWithLink>
        <Dropdown.ItemWithLink
          onClick={() => spaceModal.show({ spaceGroupId: spaceGroup.id })}
        >
          {t("add_space")}
        </Dropdown.ItemWithLink>
        <Dropdown.ItemWithLink
          onClick={() =>
            addSpaceGroupMemberModal.show({ spaceGroupId: spaceGroup.id })
          }
        >
          {t("space_groups.add_members")}
        </Dropdown.ItemWithLink>
        <Dropdown.Separator />
        <Dropdown.ItemWithLink hasDanger onClick={toggleDeleteModal}>
          {t("space_groups.delete_space_group")}
        </Dropdown.ItemWithLink>
      </Dropdown>
    </>
  );
};
